<script setup>
import { ref } from 'vue'

// 只保留必要的事件定义
const emit = defineEmits(['update-messages', 'send-question'])

// 仅保留组件内部需要的状态
const commonQuestions = ['宝宝便秘怎么办?', '不同阶段的奶粉有什么区别?', '咨询活动优惠']

// 仅保留组件内部需要的方法
const selectQuestion = (question) => {
  // 直接通知父组件发送问题，而不是放到输入区域
  emit('send-question', question)
}
</script>

<template>
  <div class="home-content">
    <div class="welcome-section">
      <div class="avatar-container">
        <img src="@/assets/Ellipse 941.png" alt="智能助手" class="avatarImg" />
        <img src="@/assets/Vector 1223.png" alt="智能助手" class="avatarVector" />
      </div>
      <img src="@/assets/headerTitle.png" alt="" class="headerTitle-image" />
      <img src="@/assets/Vector 1224.png" alt="" class="bottom-image" />
      <p>您可以直接在下方输入框粘贴输入用户咨询问题，我会为您生成专业话术建议</p>
    </div>

    <div class="common-questions">
      <h3>常见问题示例</h3>
      <div
        v-for="(question, index) in commonQuestions"
        :key="index"
        class="question-item"
        @click="selectQuestion(question)"
      >
        {{ question }}
        <img src="@/assets/Vector.png" alt="" />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 仅保留首页内容相关样式 */
.home-content {
  width: 100%;
  flex: 1;
  /* padding: 0.5rem; */
  display: flex;
  flex-direction: column;
  overflow-y: visible;
  margin-top: 0;
  background: transparent;
  height: auto;
  min-height: 0;
}

.home-content::-webkit-scrollbar {
  display: none;
}

.welcome-section {
  margin-top: 1rem;
  margin-left: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

.avatar-container {
  display: flex;
  flex-direction: column;
}

.avatarImg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  /* transform: scaleX(-1); */
  z-index: 11;
}

.avatarVector {
  width: 37.8px;
  height: 51px;
  margin-top: -2.6rem;
  z-index: 10;
}

.welcome-section h2 {
  font-family: Alimama ShuHeiTi;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 100%;
  color: #333;
  margin-bottom: 0.5rem;
}

.headerTitle-image {
  width: 300px;
  margin-top: 10px;
}

.bottom-image {
  width: 180px;
  margin-left: 7.5rem;
  margin-top: -0.6rem;
}

.welcome-section p {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #444;
  line-height: 1.5;
  margin-top: 0.5rem;
}

.common-questions {
  padding: 0.8rem;
}

.common-questions h3 {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  margin-bottom: 0.5rem;
}

.question-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  background: #ffffff66;
  padding: 0.7rem;
  border-radius: 8px;
  margin-bottom: 0.8rem;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #666;
  cursor: pointer;
}

.question-item img {
  width: 12px;
  height: 12px;
}

.question-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
